import { action, makeObservable, observable } from "mobx";

export type DimensionBlock = {
    timeChunk: DOMRect
    pixelMinuteMultiplier: number,
    channelBlock: DOMRect,
    gridMain: DOMRect,
    indexSpread: number[],
    minuteWidth: number,
    gridWidth: number,
    viewWidth: number
}

class GridStore {
    dimensionBlock?: DimensionBlock = undefined;
    verticalScrollIndexes = [0, 12];
    horizontalScrollIndexes = [0, 0];
    gridScrollIndexes = [0, 0];
    scrollParams: number[] | undefined;
    dateIndex = 0;

    constructor() {
        makeObservable(this, {
            dimensionBlock: observable,
            verticalScrollIndexes: observable,
            horizontalScrollIndexes: observable,
            gridScrollIndexes: observable,
            scrollParams: observable,

            updateDimensionBlock: action,
            updateHorizontalScrollIndexes: action,
            updateGridScrollIndexes: action,
            updateScrollParams: action,
            updateVerticalScrollIndexes: action,

            dateIndex: observable,
            updateDateIndex: action
        });
    }

    updateDimensionBlock(value: DimensionBlock) {
        this.dimensionBlock = value;
    }

    updateScrollParams(value: number[]) {
        this.scrollParams = value;
    }

    updateVerticalScrollIndexes(value: number[]) {
        this.verticalScrollIndexes = value;
    }

    updateHorizontalScrollIndexes(value: number[]) {
        this.horizontalScrollIndexes = value;
    }

    updateGridScrollIndexes(value: number[]) {
        this.gridScrollIndexes = value;
    }

    updateDateIndex(value: number) {
        this.dateIndex = value;
    }

    getDateIndex() {
        const scrollPosition = this.horizontalScrollIndexes[0] / 48;

        const floorCurrScroll = Math.floor(scrollPosition);
        const roundCurrScroll = Math.round(scrollPosition);
        const currSum = scrollPosition - floorCurrScroll;

        const index = currSum >= 0.8 ? roundCurrScroll : floorCurrScroll;
        return index;
    }
}

export default GridStore;